import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getAdminSessionMasters,
  getAdminSessionMasterById,
  createAdminSessionMaster,
  updateAdminSessionMaster,
  deleteAdminSessionMaster,
} from "../../api/admin/sessionMaster.api";

/* ============================================================
   FETCH SESSION MASTER LIST
============================================================ */

export const fetchSessionMasters = createAsyncThunk(
  "admin/sessionMaster/fetch",
  async (
    { page = 1, limit = 10, search = "" } = {},
    { rejectWithValue }
  ) => {
    try {
      const res = await getAdminSessionMasters({
        page,
        limit,
        search,
      });

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch Session Masters."
      );
    }
  }
);

/* ============================================================
   FETCH SINGLE SESSION MASTER
============================================================ */

export const fetchSessionMasterById = createAsyncThunk(
  "admin/sessionMaster/fetchById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await getAdminSessionMasterById(id);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch Session Master."
      );
    }
  }
);

/* ============================================================
   CREATE SESSION MASTER
============================================================ */

export const addSessionMaster = createAsyncThunk(
  "admin/sessionMaster/add",
  async (payload, { rejectWithValue }) => {
    try {
      console.log(
        "📡 ADD SESSION MASTER PAYLOAD:",
        payload
      );

      const res = await createAdminSessionMaster(payload);

      console.log(
        "📥 ADD SESSION MASTER RESPONSE:",
        res
      );

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;

    } catch (error) {

      return rejectWithValue(
        error.message || "Failed to create Session Master."
      );

    }
  }
);

/* ============================================================
   UPDATE SESSION MASTER
============================================================ */

export const updateSessionMaster = createAsyncThunk(
  "admin/sessionMaster/update",
  async (
    {
      id,
      sessionMasterData,
    },
    { rejectWithValue }
  ) => {
    try {
      const res = await updateAdminSessionMaster(
        id,
        sessionMasterData
      );

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;

    } catch (error) {

      return rejectWithValue(
        error.message || "Failed to update Session Master."
      );

    }
  }
);

/* ============================================================
   DELETE SESSION MASTER
============================================================ */

export const deleteSessionMaster = createAsyncThunk(
  "admin/sessionMaster/delete",
  async (
    id,
    { rejectWithValue }
  ) => {
    try {
      const res = await deleteAdminSessionMaster(id);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return {
        id,
        message: res.message,
      };

    } catch (error) {

      return rejectWithValue(
        error.message || "Failed to delete Session Master."
      );

    }
  }
);